var top:any = 100;
export class TopLayer {
    static getNextIndex():any
	{
        top++;
        return top;
	}
}